import React from 'react'
import EmbeddedReports from '../features/embeddedReports/index'

export default function EmbeddedReportsPage() {
  return (
    
    <EmbeddedReports />
  )

}